import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 13,
	viewBox: "0 0 18 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 6.25L7 10.75L17 1",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgTick;
